var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('a',{attrs:{"href":(_vm.publicPath + "pdf/" + _vm.file)}},[_vm._v("Télécharger la notice d'utilisation")])])}
var staticRenderFns = []

export { render, staticRenderFns }